/* eslint-disable no-nested-ternary */
import React, { memo, ReactElement, useEffect, useMemo } from 'react';

import { Row, TypographyText } from '@components/atoms';
import { useReduxForm } from '@hooks/useReduxForm';
import { moveFocus } from '@utils/dataUtils';
import { getSurveyObj } from '@utils/surveyUtils';

function NumberInput({ formKey }: { formKey: string }): ReactElement {
  const { formData, setFormData } = useReduxForm('survey');

  const surveyObj = useMemo(() => getSurveyObj(formKey), [formKey]);

  useEffect(() => {
    if (!formData[formKey] && surveyObj?.defaultValue) {
      setFormData({
        [formKey]: surveyObj?.defaultValue,
        [`${formKey}Next`]: 0,
      });
    }
    moveFocus(`number-input-${formKey}`);
  }, [formKey]);

  return (
    <Row
      style={{
        position: 'relative',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: '20px',
        columnGap: '5px',
      }}
    >
      <input
        autoComplete="off"
        id={`number-input-${formKey}`}
        min={1}
        onChange={(e) => {
          const { value } = e.target;
          setFormData({
            [formKey]: value,
            [`${formKey}Next`]: 0,
          });
        }}
        style={{
          border: '1px solid #d9d9d9',
          borderRadius: '4px',
          width: '100px',
          height: '50px',
          fontSize: '16px',
          lineHeight: '1em',
          paddingInline: '15px',
          textAlign: 'center',
          paddingTop: '4px',
        }}
        type="number"
        value={formData[formKey]}
      />
      {surveyObj?.postfix && (
        <Row style={{ display: 'flex', paddingTop: '4px' }}>
          <TypographyText>{surveyObj?.postfix}</TypographyText>
        </Row>
      )}
    </Row>
  );
}

export default memo(NumberInput);
